var React = require('react');

function StepIndyficatorCheckbox (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"stepIndyficatorCheckbox","d":"M425,157.5l2.744,2.744,6.421-6.421","transform":"translate(-423.586 -152.408)","fill":"none","stroke":"#628942","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

StepIndyficatorCheckbox.defaultProps = {"width":"11.993","height":"8.835","viewBox":"0 0 11.993 8.835"};

module.exports = StepIndyficatorCheckbox;

StepIndyficatorCheckbox.default = StepIndyficatorCheckbox;
